<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <v-container fluid>
              <v-card-title>
                <!--                  <v-btn :to="{name: 'config.create'}" rounded color="#308BB0" class="text-white" v-status="'config_create'">-->
                <!--                    <v-icon>mdi-plus</v-icon>-->
                <!--                    افزودن-->
                <!--                  </v-btn>-->
                <v-btn
                  :to="{ name: 'configs.rbLand' }"
                  class="btn-history"
                  v-status="'config_create'"
                >
                  <v-icon>mdi-robot</v-icon>
                  تنظیمات ربات لند
                </v-btn>

                <!--                  <v-spacer/>-->
                <!--                  {{ $t($route.meta.title) }}-->
                <!--                  <v-spacer/>-->
                <!--                  <v-btn :loading="loading" @click="reload"-->
                <!--                         class="btn-update">-->
                <!--                    <v-icon>mdi-refresh</v-icon>-->
                <!--                    به روزرسانی-->
                <!--                  </v-btn>-->
              </v-card-title>
              <v-divider />

              <div class="row">
                <div class="col-md-12 p-5">
                  <data-table
                    orderDir="desc"
                    :data="data"
                    :columns="columns"
                    class="p-2"
                    :debounce-delay="5000"
                    :translate="translate"
                    :per-page="[10, 25, 50, 100, 200, 400]"
                    @on-table-props-changed="reloadTable"
                  >
                  </data-table>
                </div>
              </div>
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="dialog"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>
            <div class="text-h3 text-center">{{ item.title }}</div></v-toolbar
          >
          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text color="pink" dark @click="dialog.value = false"
              >بستن</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";

export default {
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url: "config",
      columns: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "کلید",
          name: "key",
        },
        {
          label: "مقدار",
          name: "val",
        },

        {
          label: "توضیحات",
          name: "description",
        },

        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "config_",
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              // {
              //   name: 'show',
              //   label: 'نمایش',
              //   icon: 'eye',
              //   class:'btn-outline-info',
              // }
            ],
          },
        },
      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
    };
  },
  methods: {
    reloadTable(tableProps) {
      this.getConfigs(this.url, tableProps);
    },
    getConfigs(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {});
    },
    reload() {
      this.getConfigs(this.url, this.tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    show(data) {
      this.item = data;
      this.dialog = true;
    },
    edit(data) {
      this.$router.push({
        name: "admin.configs.show",
        params: { id: data.id },
      });
    },
  },
  created() {
    this.getConfigs(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
};
</script>
